export class Manufacturer {
  constructor(
    technicalId,
    boomerangId,
    name,
    boomerangFullSupport,
    categoryCount,
    productCount
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.name = name
    this.boomerangFullSupport = boomerangFullSupport
    this.categoryCount = categoryCount
    this.productCount = productCount
  }
}
